import { render, staticRenderFns } from "./BaiduProvider.vue?vue&type=template&id=48976a74&scoped=true"
import script from "./BaiduProvider.vue?vue&type=script&lang=js"
export * from "./BaiduProvider.vue?vue&type=script&lang=js"
import style0 from "./BaiduProvider.vue?vue&type=style&index=0&id=48976a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48976a74",
  null
  
)

export default component.exports